import React from 'react';
import { cn } from '@/shared/lib/cn';

export type StatusTone = 'success' | 'danger' | 'warning' | 'info' | 'neutral';

interface StatusBadgeProps {
    tone?: StatusTone;
    children: React.ReactNode;
    /** Ponto colorido à esquerda — reforça o estado sem depender só da cor de fundo. */
    dot?: boolean;
    className?: string;
    title?: string;
}

const TONE_VARS: Record<StatusTone, { fg: string; bg: string; border: string }> = {
    success: { fg: 'var(--status-success)', bg: 'var(--status-success-bg)', border: 'var(--status-success-border)' },
    danger: { fg: 'var(--status-danger)', bg: 'var(--status-danger-bg)', border: 'var(--status-danger-border)' },
    warning: { fg: 'var(--status-warning)', bg: 'var(--status-warning-bg)', border: 'var(--status-warning-border)' },
    info: { fg: 'var(--status-info)', bg: 'var(--status-info-bg)', border: 'var(--status-info-border)' },
    neutral: { fg: 'var(--status-neutral)', bg: 'var(--status-neutral-bg)', border: 'var(--status-neutral-border)' },
};

export function StatusBadge({ tone = 'neutral', children, dot = true, className, title }: StatusBadgeProps) {
    const v = TONE_VARS[tone];
    return (
        <span
            title={title}
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5',
                'text-xs font-medium whitespace-nowrap',
                className,
            )}
            style={{ color: v.fg, backgroundColor: v.bg, borderColor: v.border }}
        >
            {dot && (
                <span
                    aria-hidden="true"
                    className="inline-block h-1.5 w-1.5 shrink-0 rounded-full"
                    style={{ backgroundColor: v.fg }}
                />
            )}
            {children}
        </span>
    );
}


